import { ApiUtil as api } from '@/utils/api.util.js'

export class TagService {
    static URL = process.env.API_URL + process.env.API_VER
    static RESOURCE = '/tags/'

    static all(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE, queryParams)
    }

    static listTypes(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'types', queryParams)
    }

    static show(id, queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + id, queryParams)
    }

    static store(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE, queryParams)
    }

    static update(id, queryParams = {}) {
        return api.put(this.URL + this.RESOURCE + `${id}`, queryParams)
    }

    static delete(id, queryParams = {}) {
        return api.delete(this.URL + this.RESOURCE + `${id}`, queryParams)
    }

    static assign(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'assign', queryParams)
    }

    static associates(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'get/associates', queryParams)
    }

    // firm_firm

    static toggleArchived(queryParams = {}) {
        return api.put(this.URL + this.RESOURCE + 'toggle-archived/firm-firm', queryParams)
    }

    static findtags(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'find-tags', queryParams)
    }    

    static attachtag(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'attach-tag', queryParams)
    }    

    static selectedtags(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'selected-tags', queryParams)
    }
    static toggleTag(queryParams = {}) {
        return api.post(this.URL + this.RESOURCE + 'toggle/tag', queryParams)
    }
    static getTags(queryParams = {}) {
        return api.get(this.URL + this.RESOURCE + 'get/tags', queryParams)
    }    
    
    static attach(queryParams = {}) {
        return api.put(this.URL + this.RESOURCE + 'attach', queryParams)
    }

    static detach(queryParams = {}) {
        return api.put(this.URL + this.RESOURCE + 'detach', queryParams)
    }

    static attachByNames(queryParams = {}) {
        return api.put(this.URL + this.RESOURCE + 'attach-by-names', queryParams)
    }

    static detachByNames(queryParams = {}) {
        return api.put(this.URL + this.RESOURCE + 'detach-by-names', queryParams)
    }

    static archiveRates(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/archive-rates', data);
	}

	static restoreRates(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/restore-rates', data);
	}

    static archiveCodes(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/archive-codes', data);
	}

	static restoreCodes(id, data = {}) {
		return api.put(this.URL + this.RESOURCE + id + '/restore-codes', data);
	}
}



// WEBPACK FOOTER //
// ./src/services/tag.service.js